import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { LU_STContactType } from 'scaletech-core';
import { FilterParams, StarbaseDataService } from 'starbase-launcher';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class LU_ContactTypeService extends StarbaseDataService<LU_STContactType> {
  protected _staleDataTimeout = 30000;
  protected _getOneUri = '/api/LU_ContactTypes/';
  protected _getAllUri = '/api/LU_ContactTypes';
  protected _postUri = '/api/LU_ContactTypes';
  protected _putUri = '/api/LU_ContactTypes/';
  protected _deleteUri = '/api/LU_ContactTypes/';
  protected _broadSearchUri = '/api/LU_ContactTypes/GetContactTypesByFilterParams';

 getDataByFilterParamsBroadSearch(url: string, filterParams: FilterParams<LU_STContactType>):
  Observable<FilterParams<LU_STContactType>> {
    return super.getDataByFilterParamsBroadSearch(url, filterParams).pipe(
      map((l) => {
        l.collection = l.collection.map((lu) => new LU_STContactType().deserialize(lu));
        return l;
      })
    );
  }

  /** In order to properly display Last Modifed date we must override the primary getter to manually set Last Modified Date to null */
  public getAllData(url: string, retryCount?: number): Observable<LU_STContactType[]> {
    return super.getAllData(url, retryCount).pipe(
      map((l) => {
        return l.map((lu) => new LU_STContactType().deserialize(lu));
      })
    );
  }

  /** Since Last Modified Date is set to null during get we must set it to a value when saving to prevent errors. */
  public putData(url: string = this.putUri, id: string | number, changedObject: LU_STContactType) {
    // eslint-disable-next-line eqeqeq
    if (changedObject.lastModifiedDateTime == null) {
      changedObject.lastModifiedDateTime = new Date();
    }
    return super.putData(url, id, changedObject);
  }

  constructor(private _http: HttpClient, private _webAPI: WebApiService) {
    super(_http, _webAPI);
  }
}
